<div class="container">
  <h1 class=" p-2 print-hidden">Actions</h1>
  @if (!showActionSummary) {
  <div class="px-4 md:px-8 mt-2">
    <div class="mb-2 border-grey-200 border-[1px] rounded-lg p-4 bg-white shadow-sm">
      <div class="flex flex-col gap-2">
        <label class="text-sm font-semibold">Actions Reported Between:</label>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
          <p-datepicker
            styleClass="date-input"
            [(ngModel)]="startDate"
            (ngModelChange)="removeStartDateTimeZone($event)"
            dateFormat="dd M yy"
            [showIcon]="true">
          </p-datepicker>
          <p-datepicker
            styleClass="date-input"
            [(ngModel)]="endDate"
            (ngModelChange)="removeEndDateTimeZone($event)"
            dateFormat="dd M yy"
            [showIcon]="true">
          </p-datepicker>
        </div>
        <button class="text-xs text-green-700 flex items-center gap-1 w-fit" type="button" (click)="showAdvancedFilters = !showAdvancedFilters">
          <i class="pi" [ngClass]="showAdvancedFilters ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          <span class="text-sm">{{ showAdvancedFilters ? 'Hide filters' : 'Show more filters' }}</span>
        </button>
      </div>
      @if (showAdvancedFilters) {
        <div class="mt-4 border-t border-grey-200 pt-4">
          <div class="text-xs uppercase tracking-wide text-grey-600 mb-3 flex items-center gap-2">
            <i class="pi pi-sliders-h text-green-700"></i>
            <span>Advanced filters</span>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div class="flex flex-col gap-3">
              <p class="text-xs font-semibold text-grey-600">{{ 'audit' | customerTerm }}</p>
              <p-select
                styleClass="w-full prime-input"
                [options]="auditTypes"
                optionLabel="Description"
                [(ngModel)]="selectedAuditType"
                (onChange)="updateAudits()"
                [placeholder]="'Audit Type' | customerText">
              </p-select>
              <p-select
                styleClass="w-full prime-input"
                [options]="frequencies"
                optionLabel="Description"
                [(ngModel)]="selectedFrequency"
                (onChange)="updateAudits()"
                placeholder="Frequency">
              </p-select>
              <p-select
                styleClass="w-full prime-input"
                [options]="displayAudits"
                optionLabel="AuditName"
                [(ngModel)]="selectedAudit"
                [placeholder]="'audit' | customerTerm">
              </p-select>
            </div>
            <div class="flex flex-col gap-3">
              <p class="text-xs font-semibold text-grey-600">Location & Assignment</p>
              <p-select
                styleClass="w-full prime-input"
                [options]="useLocationGroups ? locationGroupsWithAll : locations"
                optionLabel="LocationName"
                optionGroupLabel="label"
                optionGroupChildren="items"
                [group]="useLocationGroups"
                [pt]="{ label: { class: 'block w-full' } }"
                [filter]="true"
                filterBy="LocationName"
                [(ngModel)]="selectedLocation"
                placeholder="Location">
                <ng-template pTemplate="group" let-group>
                  @if (group.label) {
                    <div class="font-semibold text-xs uppercase text-grey-500">
                      {{group.label}}
                    </div>
                  }
                </ng-template>
                <ng-template pTemplate="selectedItem" let-location>
                  <span class="block w-full">{{location?.LocationName}}</span>
                </ng-template>
              </p-select>
              <p-select
                styleClass="w-full prime-input"
                [options]="users"
                optionLabel="DisplayName"
                [(ngModel)]="selectedUser"
                placeholder="Assigned to">
                <ng-template pTemplate="item" let-user>
                  <span [ngClass]="{'font-bold': user?.UserTypeID === 2}">{{ user?.DisplayName }}</span>
                </ng-template>
                <ng-template pTemplate="selectedItem" let-user>
                  <span [ngClass]="{'font-bold': user?.UserTypeID === 2}">{{ user?.DisplayName }}</span>
                </ng-template>
              </p-select>
            </div>
            <div class="flex flex-col gap-3">
              <p class="text-xs font-semibold text-grey-600">Status & Scope</p>
              <div class="flex items-center justify-between gap-2 text-sm">
                <p>Include Resolved</p>
                <app-toggle-switch [(checked)]="includeComplete"></app-toggle-switch>
              </div>
              <div class="flex items-center justify-between gap-2 text-sm">
                <p>Overdue Only</p>
                <app-toggle-switch [(checked)]="overdueonly"></app-toggle-switch>
              </div>
              <div class="flex items-center justify-between gap-2 text-sm">
                <p>Include Sublocations</p>
                <app-toggle-switch [(checked)]="IncludeSubLocations"></app-toggle-switch>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="flex justify-end mt-3 px-4 md:px-8">
    <button class="btn-primary text-lg w-full md:w-auto" (click)="refreshSearch()" [disabled]="isLoading">
      @if (isLoading) {
        <span>Loading...</span>
      } @else {
        <span>Load Actions</span>
      }
    </button>
  </div>

  <div class="mt-8 actions-summary">
    <p class="md:px-8 font-bold md:text-sm text-xs mx-2">Summary of Selected Actions</p>
    <div class="flex md:px-8 mb-4 mx-2 summary-row" [ngClass]="{'summary-5': showResolvedCount, 'summary-4': !showResolvedCount}">
      <div [ngClass]="{'w-1/5':showResolvedCount,'w-1/4':!showResolvedCount}"
        class="summary-item rounded-l-lg py-1 border-l-2 border-l-grey-500 border-y-2 border-y-grey-500 flex flex-col justify-center align-middle">
        <p class="text-center standardTextSize summary-label">Total</p>
        <p class="text-center text-xl font-bold summary-value">{{totalActionCount}}</p>
      </div>
      <div [ngClass]="{'w-1/5':showResolvedCount,'w-1/4':!showResolvedCount}"
        class="summary-item py-1 bg-danger-base flex flex-col justify-center align-middle">
        <p class="text-standardwhite text-center standardTextSize summary-label">Overdue</p>
        <p class="text-standardwhite text-center text-xl font-bold summary-value">{{totalOverdueActionCount}}</p>
      </div>
      <div [ngClass]="{'w-1/5':showResolvedCount,'w-1/4':!showResolvedCount}"
        class="summary-item py-1 bg-warning-base flex flex-col justify-center align-middle">
        <p class="text-center standardTextSize summary-label">Due Today</p>
        <p class="text-center text-xl font-bold summary-value">{{totalDueActionCount}}</p>
      </div>
      <div [ngClass]="{'w-1/5':showResolvedCount,'w-1/4  rounded-r-lg':!showResolvedCount}"
        class="summary-item py-1 bg-green-700 flex flex-col justify-center align-middle">
        <p class="text-standardwhite text-center standardTextSize summary-label">Not Due</p>
        <p class="text-standardwhite text-center text-xl font-bold summary-value">{{totalActionsNotDueCount}}</p>
      </div>
      @if (showResolvedCount) {
        <div class="summary-item bg-grey-900 w-1/5 flex flex-col justify-center align-middle py-1 rounded-r-lg">
          <p class="text-standardwhite text-center standardTextSize summary-label">Resolved</p>
          <p class="text-standardwhite text-center text-xl font-bold summary-value">{{totalResolvedCount}}</p>
        </div>
      }
    </div>
  </div>

  <div class="px-8">
    <div class="primary-green-border w-full border-grey-500"></div>
  </div>

  <div class="lg:mx-8 p-2 actions-list-wrapper">
    <div class="text-right my-2 mb-4">
      <div class="flex items-center justify-end gap-3">
        <div class="flex items-center gap-1 text-xs text-grey-700">
          <span class="text-sm">Expand all actions</span>
          <app-toggle-switch [(checked)]="expandAll"></app-toggle-switch>
        </div>
        <button class="btn-inverse h-auto text-xs" (click)="exportActionList()">Export</button>
        @if (canShowActionSummary) {
          <button class="btn-inverse h-auto text-xs" (click)="showActionSummaryView()">Action Summary</button>
        }
      </div>
    </div>
    @if (actionList.Actions.length>0) {
      <div>
        @for (action of actionList.Actions; track action) {
          <div>
            <app-compact-action-panel [action]="action" [origin]="'actions'" [filterState]="filterStateParam" [forceExpanded]="expandAll" (Refresh)="refreshActionData()"></app-compact-action-panel>
          </div>
        }
        @if (actionPagingAvailable && totalResultCount > pageSize) {
          <div class="mt-4 paginator-wrapper" [ngClass]="{'pointer-events-none opacity-70': isLoading}">
            <p-paginator
              [first]="firstResult"
              [rows]="pageSize"
              [totalRecords]="totalResultCount"
              [rowsPerPageOptions]="pageSizeOptions"
              (onPageChange)="onActionsPageChange($event)">
            </p-paginator>
          </div>
        }
      </div>
    }
  </div>
  }

  @if (showActionSummary && canShowActionSummary) {
    <div class="px-4 md:px-8 mt-4 print-no-padding">
      <div class="hidden print-flex justify-center -mt-2 mb-3">
        <img class="h-14" src="/assets/logo.png" />
      </div>
      <div class="flex justify-between items-center mb-4 print-hidden">
        <h2 class="print-hidden">Action Summary</h2>
        <div class="flex items-center gap-2">
          <button class="btn-inverse h-auto text-xs" (click)="printActionSummary()">Print</button>
          <button class="btn-inverse h-auto text-xs" (click)="hideActionSummary()">Back to actions</button>
        </div>
      </div>
      <table class="mt-2 mb-6 w-full table-auto bg-standardwhite border border-grey-900 action-table rounded-sm print-ml-1">
        <thead>
          <tr class="border-b-[1px] border-green-700">
            <th class="text-left print-text-xs pr-1 border-r-[1px] border-grey-300">{{ 'audit' | customerTerm }}</th>
            <th class="text-left print-text-xs pr-1 border-r-[1px] border-grey-300">Location</th>
            <th class="text-left print-text-xs pr-1 border-r-[1px] border-grey-300">{{ 'audit' | customerTerm }} Date</th>
            <th class="text-left print-text-xs pr-1 border-r-[1px] border-grey-300">Question</th>
            <th class="text-left print-text-xs pr-1 border-r-[1px] border-grey-300">Answer</th>
            @if (summaryHasComments) {
              <th class="text-left pr-1 border-r-[1px] print-text-xs border-grey-300">Comments</th>
            }
            @if (summaryHasReference) {
              <th class="text-left pr-1 border-r-[1px] print-text-xs border-grey-300">Reference</th>
            }
            <th class="text-left pr-1 border-r-[1px] border-grey-300 print-text-xs">Action</th>
            <th class="text-left pr-1 border-r-[1px] border-grey-300 print-text-xs">Action Owner</th>
            <th class="text-left pr-1 border-r-[1px] border-grey-300 print-text-xs">Action Due</th>
            <th class="text-left pr-1 print-text-xs">Resolved</th>
          </tr>
        </thead>
        <tbody>
          @for (action of summaryActions; track action) {
            <tr class="border-b-[1px] border-grey-300">
              <td class="border-r-[1px] border-grey-300 print-text-xs" [ngClass]="{'pl-6': action.ParentActionID > 0}">{{ action.AuditName }}</td>
              <td class="border-r-[1px] border-grey-300 print-text-xs">{{ action.AuditLocation.LocationName }}</td>
              <td class="border-r-[1px] border-grey-300 print-text-xs text-xs">@if (action.AuditCompletedDate) {
                <span class="print-text-xs text-xs">{{ displayDate(action.AuditCompletedDate) }}</span>
              }</td>
              <td class="border-r-[1px] border-grey-300 max-w-[50%] print-text-xs">
                {{ action.QuestionHeader }}
                @if (action.QuestionBody) {
                  <p class="print-text-xs text-xs text-grey-900">{{ action.QuestionBody }}</p>
                }
              </td>
              <td class="border-r-[1px] border-grey-300 print-text-xs">{{ action.Result }}</td>
              @if (summaryHasComments) {
                <td class="border-r-[1px] border-grey-300 print-text-xs">{{ action.Comments }}</td>
              }
              @if (summaryHasReference) {
                <td class="border-r-[1px] border-grey-300 max-w-72 print-text-xs text-xs">
                  @if (action.ReferenceQuestionHeader) {
                    <p class="print-text-xs text-xs">{{ action.ReferenceQuestionHeader }}</p>
                  }
                  @if (action.ReferenceQuestionBody) {
                    <p class="print-text-xs text-xs">{{ action.ReferenceQuestionBody }}</p>
                  }
                  @if (action.Reference) {
                    <p class="font-semibold mt-1 print-text-xs text-center text-xs">{{ action.Reference }}</p>
                  }
                </td>
              }
              <td class="border-r-[1px] border-grey-300 print-text-xs">{{ action.ActionDescription }}</td>
              <td class="border-r-[1px] border-grey-300 print-text-xs text-center">{{ action.ActionAssignee }}</td>
              <td class="border-r-[1px] border-grey-300 print-text-xs text-center">{{ displayDate(action.ActionDeadline) }}</td>
              <td class="print-text-xs">
                @if (action.Resolved) {
                  <p class="print-text-xs text-xs">{{ displayDate(action.ResolvedDate) }}</p>
                  <p class="print-text-xs text-xs">By <span class="print-text-xs text-xs font-bold">{{ action.ResolvedUser }}</span></p>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }</div>




